import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { Values } from '../../values/Values';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    overflow: 'hidden'
  },
  divImagemPrincipal: {
    paddingRight: 30,
    paddingLeft: 30,
    alignItems: 'center'
  },
  imagemPrincipal: {
    borderRadius: 15,
    height:250,
    width:'100%',
  },
  avatarCtg: {
    zIndex: 1,
    marginTop: -45,
    backgroundColor:'#F5F5F5',
    height: theme.spacing(10),
    width: theme.spacing(10),
  },
  imageAvatar: {
    height: theme.spacing(8),
    width: theme.spacing(8)
  },
  cardConfiguracoes: {
    marginLeft: 30,
    marginRight: 30,
    marginTop: 20,
    borderRadius: 15
  },
  gridAvatarCards: {
    display: 'flex',
    justifyContent: 'center',
  },
  avatarCards: {
    backgroundColor: Values.cores.branco
  },
  iconAvatarCards: {
    fontSize: '32px',
    color: Values.cores.corPrimaria
  },
  gridTextoCards: {
    display: 'flex',
    justifyContent: 'center',
  },
  textoCards: {
    fontWeight: 'bolder'
  },
  gridCards: {
    padding: 50
  }
}));

export {useStyles}




